/* eslint-disable camelcase */

export default function saveTokensToCookies(
  lyearn_token,
  provider_id_token,
  provider_refresh_token,
  loginMode,
  access_keyId,
  secret_key,
  session_token
) {
  const currentMillis = new Date().getTime() + 5 * 60 * 60 * 1000;
  const utcDate = new Date(currentMillis).toUTCString();
  document.cookie = 'lyearn_token =' + lyearn_token + ';expires=' + utcDate;
  document.cookie = 'provider_id_token =' + provider_id_token + ';expires=' + utcDate;
  document.cookie = 'provider_refresh_token =' + provider_refresh_token + ';expires=' + utcDate;
  document.cookie = 'loginMode =' + loginMode + ';expires=' + utcDate;
  document.cookie = 'cognito_access_key =' + access_keyId + ';expires=' + utcDate;
  document.cookie = 'cognito_secret_key =' + secret_key + ';expires=' + utcDate;
  document.cookie = 'cognito_session_token =' + session_token + ';expires=' + utcDate;
}
